import { EmailIcon } from '@/components/icons/email-icon';
import { Button } from '@/components/ui/button';
import clsx from 'clsx';
import { usePathname } from 'next/navigation';
import React, { useEffect, useState } from 'react';
import { EmailSubscribeForm } from './email-subscribe-form/email-subscribe-form';
import emailUpdatesBarStyles from './email-updates-bar.module.scss';

export const EmailUpdatesBar = (): React.JSX.Element => {
  const pathName = usePathname();
  const [showSubscribe, setShowSubscribe] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    if (pathName) {
      setShowSubscribe(false);
    }
  }, [pathName]);

  const onClose = (success?: boolean): void => {
    setShowSubscribe(false);
    setShowSuccessMessage(!!success);
  };

  const showSubscribeTextOrEmailInput = (): React.JSX.Element => {
    if (showSubscribe) {
      return <EmailSubscribeForm onClose={onClose} />;
    }

    return <>
      {showSuccessMessage &&
        <p className="font-bold"
          data-test="email-updates-bar-success-message"
        >
          Thanks for subscribing!
        </p>
      }

      {!showSuccessMessage &&
        <p className={clsx('font-bold', emailUpdatesBarStyles.header)}
          data-test="email-updates-bar-header"
        >
          Get email updates about movies, rewards and more!{' '}
          <Button className={emailUpdatesBarStyles.subscribe}
            data-test="button-toggle-email-subscribe"
            type="button"
            variant="link"
            onClick={() => setShowSubscribe(true)}
          >
            <EmailIcon className="icon"
              focusable="false"
              role="img"
            >
              <title id="icon-title-subscribe">Subscribe to our emails</title>
            </EmailIcon>
            Subscribe to our emails
          </Button>
        </p>
      }
    </>;
  };

  return (
    <div className={clsx(emailUpdatesBarStyles.bar, showSubscribe && emailUpdatesBarStyles.expanded)}>
      {showSubscribeTextOrEmailInput()}
    </div>
  );
};
